import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
//导入页面组件
import LoginView from '@/views/LoginView.vue'
import LayoutMain from '@/views/LayoutMain.vue'
import HomeView from '@/views/HomeView.vue'
import CourseWare from '@/views/CourseWare.vue'
import AboutView from '@/views/AboutView.vue'
import RegisterView from '@/views/RegisterView.vue'
import FormSurvey from '@/components/FormSurvey.vue'
import VirtualPatient from '@/views/VirtualPatient.vue'


const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path:'/register',
    name:'register',
    component: RegisterView
  },
  {
    path: '/',
    component: LayoutMain,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: HomeView
      },
      {
        path:'/course/basic',
        name:'courseBasic',
        component: CourseWare
      },
      {
        path:'/course/acute',
        name:'courseAcute',
        component: CourseWare
      },
      {
        path:'/course/subacute',
        name:'courseSubacute',
        component: CourseWare
      },
      {
        path:'/course/homeRehab',
        name:'courseHomeRehab',
        component: CourseWare
      },
      {
        //把path改成驼峰virtualPatient
        path: '/virtualPatient',
        name: 'virtualPatient',
        component: VirtualPatient
      },
      {
        path: '/survey/pre-test',
        name: 'preTestSurvey',
        component: FormSurvey
      },
      {
        path: '/survey/post-test',
        name: 'postTestSurvey',
        component: FormSurvey
      },
      {
        path: '/discussion',
        name: 'Discussion',
        component: () => import('@/views/Discussion.vue')
      },
      {
        path: '/discussion/detail',
        name: 'DiscussionDetail',
        component: () => import('@/views/DiscussionDetail.vue')
      },
      {
        path: '/about',
        name: 'about',
        component: AboutView
      },
    ]
  }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// =========全局路由守卫：只做token登录鉴权，不调用任何后端接口=========
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const whiteList = ['/login', '/register']

  // 1.未登录
  if (!token) {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
    return
  }

  // 2.已登录，禁止访问登录注册页
  if (whiteList.includes(to.path)) {
    next('/home')
    return
  }

  // token校验通过，直接放行；问卷业务判断放到LayoutMain.vue
  next()
})

// 捕获路由重复跳转警告
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router